/**
 * Placement for RIGHT-aligned chart overlays (the position-size pill).
 *
 * Two things this deliberately does NOT do:
 *
 * - It does not use `stackBase`. That drives the LEFT-aligned legend stack and
 *   reserves a row for the OHLC header, which a right-aligned pill never
 *   collides with.
 * - It does not measure the floating toolbar. That strip hosts the OHLC
 *   readout as a WRAPPING flex item, so its height flips between one and two
 *   rows as the crosshair moves and changes the readout's width. Feeding that
 *   into `top` made the pill drop a row and drift under the pointer. The
 *   floating drawing bar avoids the same hazard by deriving its geometry from
 *   a fixed anchor percentage rather than any measured toolbar height.
 *
 * Nor does it reserve a vertical band for the toolbar's right-hand tool
 * cluster: that cluster is `opacity-0` until the chart is hovered, so the
 * reservation read as ~30px of dead canvas above the pill at rest. The pill
 * rides the top edge instead. The two can come within a few px of each other
 * while the cursor is over the chart, which is the accepted trade for keeping
 * the pill tucked against the axis where it belongs.
 */

/** Gap between the pill and the price-axis strip. */
const AXIS_GUTTER = 8

export function rightRailTop(input: { overlayTopInset: number }): number {
  return 4 + input.overlayTopInset
}

/**
 * Offset from the container's right edge: clear of the price-axis strip, but
 * only just. The pill belongs inside the plot area against the axis, not
 * floated out over the candles.
 */
export function rightRailRight(input: { yAxisWidth: number }): number {
  return input.yAxisWidth + AXIS_GUTTER
}
